module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('section', {
    staticClass: "main_section"
  }), _vm._v(" "), _c('section', {
    staticClass: "pa-5 bg--white"
  }, [_c('v-row', {
    staticClass: "text-xs-left"
  }, [_c('v-col', {
    attrs: {
      "sm4": ""
    }
  }, [_c('img', {
    staticClass: "hidden-sm-and-down",
    attrs: {
      "src": require("../assets/images/pic_02.jpg"),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm8": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "sm8": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/modern.svg"),
      "width": "100%"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "2em",
      "margin-top": "-0.5em"
    }
  }, [_vm._v("暢遊臺中 - 魅力城市")])]), _vm._v(" "), _c('v-col', {
    staticClass: "text-xs-center hidden-md-and-down",
    attrs: {
      "sm4": ""
    }
  }, [_c('img', {
    staticStyle: {
      "margin-top": "1em"
    },
    attrs: {
      "src": require("../assets/images/using_tip.svg"),
      "width": "140"
    }
  })])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "float-description hidden-md-and-down"
  }, [_c('v-col', {
    attrs: {
      "sm12": ""
    }
  }, [_vm._v("一本專為國人打造的旅遊英語教材，讓你大玩特玩學英語！擁有本書讓你馬上變身專業英語導遊、成為最稱職的國民外交家！")])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "hidden-lg-and-up"
  }, [_c('v-col', {
    attrs: {
      "sm12": "",
      "mb-3": "",
      "pa-3": ""
    }
  }, [_c('span', {
    staticClass: "sub-title"
  }, [_vm._v("Using Tips")]), _vm._v(" "), _c('p', {
    staticClass: "sub-content"
  }, [_vm._v("一本專為國人打造的旅遊英語教材，讓你大玩特玩學英語！擁有本書讓你馬上變身專業英語導遊、成為最稱職的國民外交家！")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "sm6": "",
      "pa-4": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "sub-title"
  }, [_vm._v("景點介紹")]), _vm._v(" "), _c('p', {
    staticClass: "sub-content"
  }, [_vm._v("景點介紹內容採中英對照，下方會提示重點單字。讀者可清楚了解該景點的歷史、文化、由來等相關資訊，加深對景點的印象，進一步自我練習。")])])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm6": "",
      "pa-4": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "sub-title"
  }, [_vm._v("實景會話")]), _vm._v(" "), _c('p', {
    staticClass: "sub-content"
  }, [_vm._v("實景會話透過中外籍老師實地走訪該景點，對話內容的臨場感與心情感受，都是在旅遊時會用到的實用句型。另外也補充貼心小知識給讀者參考。")])])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm6": "",
      "pa-4": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "sub-title"
  }, [_vm._v("周邊旅遊資訊")]), _vm._v(" "), _c('p', {
    staticClass: "sub-content"
  }, [_vm._v("週邊旅遊資訊提供主景點附近有關的各種旅遊資訊，以及特色店家的最新消息。不過提醒讀者們前往時，還是要與店家確定營業時間喔。")])])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm6": "",
      "pa-4": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "sub-title"
  }, [_vm._v("學習音檔MP3")]), _vm._v(" "), _c('p', {
    staticClass: "sub-content"
  }, [_vm._v("學習音檔MP3本書提倡環保，因此不提供音檔光碟。在這裡要麻煩各位讀者到我們提供的"), _c('span', [_c('a', {
    on: {
      "click": function($event) {
        _vm.$router.push('/mp3')
      }
    }
  }, [_vm._v("下載網頁")])]), _vm._v("，尋找並下載書中的課程與音檔。")])])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('section', {
    staticClass: "pa-5 bg--primary"
  }, [_c('v-row', {
    staticClass: "text-xs-left"
  }, [_c('v-col', {
    attrs: {
      "offset-sm1": "",
      "sm3": ""
    }
  }, [_c('p', [_vm._v("關於我們")]), _vm._v(" "), _c('p', [_vm._v("\n          LiveABC互動英語教學集團創立以來持續研發數位內容，每月持續發行雜誌、叢書、教科書等出版品，目前已經累積超過千本的數位語言學習產品，內容包含兒童美語、檢測英語、商業英語、文法寫作、生活會話、華語學習等豐富主題，可滿足各階段的學習需求。\n        ")])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "offset-sm1": "",
      "sm3": ""
    }
  }, [_c('p', [_vm._v("相關連結")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "http://www.liveabc.com"
    }
  }, [_vm._v("LiveABC互動英語")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/channel/UC_oJU8ulza90Njx5zVb2hCw"
    }
  }, [_vm._v("LiveABC互動英語 - Youtube")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/LiveABC/"
    }
  }, [_vm._v("LiveABC互動英語 - Facebook")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "http://www.pubu.com.tw/store/12341"
    }
  }, [_vm._v("LiveABC的書店 - Pubu電子書城")])])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-561c9c46"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book.vue
// module id = 633
// module chunks = 1